var path = 'components/timewindow-button.tpl.html';
var html = " <md-button ng-disabled=disabled class=\"md-raised md-primary\" ng-click=openEditMode($event)> <ng-md-icon icon=query_builder></ng-md-icon> <span>{{model.displayValue}}</span> </md-button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/timewindow-button.tpl.html
// module id = 1488
// module chunks = 1